import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import ProjectNamespaceTreeRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceTreeRequest';
import GetParentPathRequest from '../../../projects/groups/i-service/model/namespaces/GetParentPathRequest';
import ProjectNamespaceListRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceListRequest';
import ProjectNamespaceCreateRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceCreateRequest';
import ProjectNamespaceUpdateRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateRequest';
import ProjectNamespaceUpdateNameRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateNameRequest';
import GetNamespaceByIdRequest from '../../../projects/groups/i-service/model/namespaces/GetNamespaceByIdRequest';
import ProjectNamespaceDeleteRequest from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceDeleteRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import ProjectNamespaceTreeResponse from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceTreeResponse';
import ProjectNamespaceTreeItem from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceTreeItem';
import ProjectNamespaceListResponse from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceListResponse';
import ProjectNamespaceListItem from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceListItem';
import ProjectNamespaceUpdateNameResponse from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateNameResponse';
import GetNamespaceByIdResponse from '../../../projects/groups/i-service/model/namespaces/GetNamespaceByIdResponse';
import ProjectNamespaceCreateEventResponse from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceCreateEventResponse';
import ProjectNamespaceUpdateEventResponse from '../../../projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateEventResponse';
import OnDeleteNamespaceEventResponse from '../../../projects/groups/i-service/model/namespaces/OnDeleteNamespaceEventResponse';

/**
 * * Сервис управления неймспейсами
 */
export default class ProjectNamespaceService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Добавить неймспейс в проект
	 */
	CreateEvent = new Events<WsResponseModelT<ProjectNamespaceListItem>>();
	/**
	 * * Обновить неймспейс
	 */
	UpdateEvent = new Events<WsResponseModelT<ProjectNamespaceListItem>>();
	/**
	 * * Сменить имя
	 */
	UpdateNameEvent = new Events<WsResponseModelT<ProjectNamespaceUpdateNameResponse>>();
	/**
	 * * Удалить неймспейс из проекта
	 */
	DeleteEvent = new Events<WsResponseModelT<String>>();
	/**
	 * * Заглушка события создания области видимости
	 */
	OnCreateNamespaceEventEvent = new Events<WsResponseModelT<ProjectNamespaceCreateEventResponse>>();
	/**
	 * * Заглушка события обновление области видимости
	 */
	OnUpdateNamespaceEventEvent = new Events<WsResponseModelT<ProjectNamespaceUpdateEventResponse>>();
	/**
	 * * Заглушка события удаление области видимости
	 */
	OnDeleteNamespaceEventEvent = new Events<WsResponseModelT<OnDeleteNamespaceEventResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectNamespaceService', 'Create', 'Main', (res: WsResponseModelT<ProjectNamespaceListItem>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'Update', 'Main', (res: WsResponseModelT<ProjectNamespaceListItem>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'UpdateName', 'Main', (res: WsResponseModelT<ProjectNamespaceUpdateNameResponse>) => {
			self.UpdateNameEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'Delete', 'Main', (res: WsResponseModelT<String>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'OnCreateNamespaceEvent', 'Main', (res: WsResponseModelT<ProjectNamespaceCreateEventResponse>) => {
			self.OnCreateNamespaceEventEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'OnUpdateNamespaceEvent', 'Main', (res: WsResponseModelT<ProjectNamespaceUpdateEventResponse>) => {
			self.OnUpdateNamespaceEventEvent.trigger(res);
		});
		webApiService.on('ProjectNamespaceService', 'OnDeleteNamespaceEvent', 'Main', (res: WsResponseModelT<OnDeleteNamespaceEventResponse>) => {
			self.OnDeleteNamespaceEventEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получить дерево неймспейсов папок и очередей
	 */
	async GetTree(request: ProjectNamespaceTreeRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'GetTree',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение "хлебных крошек"
	 */
	async GetParentPath(request: GetParentPathRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'GetParentPath',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список Неймспейсов
	 */
	async GetList(request: ProjectNamespaceListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'GetList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить неймспейс в проект
	 */
	async Create(request: ProjectNamespaceCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'Create',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновить неймспейс
	 */
	async Update(request: ProjectNamespaceUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'Update',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Сменить имя
	 */
	async UpdateName(request: ProjectNamespaceUpdateNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'UpdateName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение рабочего пространства по id
	 */
	async GetNamespaceById(request: GetNamespaceByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'GetNamespaceById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить неймспейс из проекта
	 */
	async Delete(request: ProjectNamespaceDeleteRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectNamespaceService',
			Method: 'Delete',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получить дерево неймспейсов папок и очередей
	 */
	async getTreeAsync(request: ProjectNamespaceTreeRequest): Promise<ProjectNamespaceTreeResponse> {
		return new Promise<ProjectNamespaceTreeResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'GetTree',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceTreeResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceTreeResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение "хлебных крошек"
	 */
	async getParentPathAsync(request: GetParentPathRequest): Promise<ProjectNamespaceTreeItem> {
		return new Promise<ProjectNamespaceTreeItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'GetParentPath',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceTreeItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceTreeItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список Неймспейсов
	 */
	async getListAsync(request: ProjectNamespaceListRequest): Promise<ProjectNamespaceListResponse> {
		return new Promise<ProjectNamespaceListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'GetList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить неймспейс в проект
	 */
	async createAsync(request: ProjectNamespaceCreateRequest): Promise<ProjectNamespaceListItem> {
		return new Promise<ProjectNamespaceListItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'Create',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceListItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceListItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновить неймспейс
	 */
	async updateAsync(request: ProjectNamespaceUpdateRequest): Promise<ProjectNamespaceListItem> {
		return new Promise<ProjectNamespaceListItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'Update',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceListItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceListItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Сменить имя
	 */
	async updateNameAsync(request: ProjectNamespaceUpdateNameRequest): Promise<ProjectNamespaceUpdateNameResponse> {
		return new Promise<ProjectNamespaceUpdateNameResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'UpdateName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectNamespaceUpdateNameResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectNamespaceUpdateNameResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение рабочего пространства по id
	 */
	async getNamespaceByIdAsync(request: GetNamespaceByIdRequest): Promise<GetNamespaceByIdResponse> {
		return new Promise<GetNamespaceByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'GetNamespaceById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetNamespaceByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetNamespaceByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить неймспейс из проекта
	 */
	async deleteAsync(request: ProjectNamespaceDeleteRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectNamespaceService',
				Method: 'Delete',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}